<template>
  <div class="container-dente-item">
    <v-img :src="createUrlOdontograma(imagem)" class="imagem-dente" lazy-src="/images/loading.gif">
      <div class="container-badge-dente" v-if="possuiProcedimentos" :style="`--cor-dente: ${corDente}`">
        <div class="container-procedimento">
          <v-img v-if="foiExtraido" src="/images/alicate-forceps.png"
                 class="imagem-procedimento"/>
          <v-img v-if="possuiCanal" src="/images/implante-dente.png"
                 class="imagem-procedimento"/>
          <v-img v-if="possuiRestauracao" src="/images/espelho-bucal-restauracao.png"
                 class="imagem-procedimento"/>
        </div>
      </div>
    </v-img>
  </div>
</template>

<script>
export default {
    nome: 'OdontogramaDente',
    props: {
        imagem: {
            type: String,
            required: true
        },
        possuiProcedimentos: {
            type: Boolean,
            required: true
        },
        possuiCanal: {
            type: Boolean,
            default: false
        },
        foiExtraido: {
            type: Boolean,
            default: false
        },
        possuiRestauracao: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            corDente: 'rgba(239, 249, 240, 0.5)'
        }
    },
    methods: {}
}
</script>

<style scoped lang="stylus">

.imagem-dente
  height 100px
  width 50px

.imagem-procedimento
  height 30px
  width 30px

.container-badge-dente
  height 100px
  width 50px
  background-color var(--cor-dente)
  border-radius 5px

.container-procedimento
  float right

</style>